import { render, staticRenderFns } from "./FolderPageList.vue?vue&type=template&id=3f19b013&scoped=true&"
import script from "./FolderPageList.vue?vue&type=script&lang=js&"
export * from "./FolderPageList.vue?vue&type=script&lang=js&"
import style0 from "./FolderPageList.vue?vue&type=style&index=0&id=3f19b013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f19b013",
  null
  
)

export default component.exports